/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import {
  Spinner,
  Table,
  CenteredContainerDisplay,
  Warning,
  SvgIcon,
  SpanWithData
} from '../'

export class Downloads extends React.PureComponent {
  static propTypes = {
    language: PropTypes.string,
    search: PropTypes.string,
    orderBy: PropTypes.string,
    onClick: PropTypes.func,
    changeSort: PropTypes.func.isRequired,
    className: PropTypes.string
  }

  showFile = (assetUrl) => window.location = assetUrl

  render() {
    if (this.props.data.loading) {
      return (
        <CenteredContainerDisplay
          content={
            <Spinner className='slds-is-relative' />  // TODO: loading state stencil instead
          }
          yAdjustPercentage={-15}
        />
      )
    }

    if (this.props.data.error) {
      return (
        <Warning>
          Error loading download data.
        </Warning>
      )
    }

    if (this.props.data.filetypes.edges.length === 0) {
      return (
        <div className='slds-m-around_large'>
          <SvgIcon
            variant='utility'
            symbol='info'
            colour='light'
            size='small'
            className='slds-m-right_small'
          />
          No download records found.
        </div>
      )
    }

    let tableColumns = ['Name', 'Translated name', 'Language']
    let filetypes = this.props.data.filetypes.edges
    let fileTypesWithAssets = filetypes.filter(fileType => fileType.node.asset !== null)

    return (
      <div className={this.props.className ? this.props.className : ''}>
        <Table
          columns={tableColumns}
          rows={fileTypesWithAssets.map(fileType => (
            <DownloadsRow
              fileType={fileType.node}
              onClick={assetUrl => this.showFile(assetUrl)}
              key={`downloadsRow_${fileType.id}`}
            />
          ))}
          objectRows={true}
          orderBy={this.props.orderBy}
          changeSort={this.props.changeSort}
          querySortableColumns={{
            'Name': {
              orderByName: 'name'
            }
          }}
        />
      </div>
    )
  }
}

const DownloadsRow = ({ fileType, onClick }) => (
  <tr className='clickable' onClick={() => onClick(fileType.asset.url)}>
    <td data-label='Name'>
      {fileType.name}
    </td>
    <td data-label='Translated name'>
      {fileType.nameTranslated}
    </td>
    <td data-label='Language'>
      <SpanWithData forField='FileTypeLanguage' searchKey={fileType.language} />
    </td>
  </tr>
)

const getRecords = gql`
  query($language: String, $search: String, $orderBy: String!) {
    filetypes(audience: "client", language: $language, name_Icontains: $search, orderBy: $orderBy) {
      edges {
        node {
          id
          name
          nameTranslated
          language
          audience
          asset {
            id
            url
          }
        }
      }
      pageInfo {
        endCursor
        startCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`

const withData =
  graphql(getRecords, {
    options: ({ language, search, orderBy }) => ({
      variables: {
        language,
        search,
        orderBy
      },
      fetchPolicy: 'network-only'
    })
  })

export default withData(Downloads)



// WEBPACK FOOTER //
// ./src/components/downloads/index.js